import { Injectable, Inject } from "@angular/core";
import {CanActivate,Router} from '@angular/router';
@Injectable()
export class LockGuard  implements CanActivate{
  constructor(private router:Router){}
  canActivate(){   //如果后期配置是否有锁屏页面在这个函数里面做判断，没有锁屏页面的情况下函数return true;
    if(localStorage.getItem('lockBol')){
      this.router.navigate(['lock']);
      return false;
    }
    return true;
  }
}
